import React from 'react';
import { connect } from 'react-redux';
import { Modal, Header, Table, Input } from 'semantic-ui-react';
import styled from 'styled-components';
import { getProducts, setProducts } from '../../../../../actions/dishSearch';
import ProductListItem from './ProductListItem';

export const ProductsListModal = ({ onClose, products, setProducts }) => {
  const [modalProductsList, setModalProductsList] = React.useState(products);

  const onEdit = React.useCallback((newName, productId) => {
    const newModalProductsList = JSON.parse(JSON.stringify(modalProductsList));
    for (let i = 0; i < newModalProductsList.length; i++) {
      if (newModalProductsList[i].id === productId) {
        newModalProductsList[i].name = newName;
        break;
      }
    }
    setModalProductsList(newModalProductsList); // edit product in the modal
    const newProducts = JSON.parse(JSON.stringify(products));
    for (let i = 0; i < newProducts.length; i++) {
      if (newProducts[i].id === productId) {
        newProducts[i].name = newName;
        break;
      }
    }
    setProducts(newProducts); // edit product in the store
  });

  const onDelete = React.useCallback((productId) => {
    const newModalProductsList = modalProductsList.filter((product) => product.id !== productId);
    setModalProductsList(newModalProductsList); // delete product in the modal
    const newProducts = products.filter((product) => product.id !== productId);
    setProducts(newProducts); // delete product in the store
  });

  const onSearch = (e) => {
    if (e.target.value === '') {
      setModalProductsList(products);
      return;
    }
    const lowerCaseValue = e.target.value.toLowerCase();
    const newProductsList = products.filter((product) => {
      const lowerCaseProductName = product.name.toLowerCase();
      return lowerCaseProductName.includes(lowerCaseValue);
    });
    setModalProductsList(newProductsList);
  };

  return (
    <Modal open onClose={onClose} size="small" style={{ padding: 20 }} closeIcon>
      <WrapModalContent>
        <WrapBlock>
          <Header textAlign="center" as="h3">
            Все ингредиенты
          </Header>
        </WrapBlock>
        <WrapBlock>
          <Input fluid label="Поиск" placeholder="Введите название блюда" onChange={onSearch} />
          <Table celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Название ингредиента</Table.HeaderCell>
                <Table.HeaderCell>Действия</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {modalProductsList.map((product) => (
                <ProductListItem
                  key={product.name + product.id}
                  id={product.id}
                  name={product.name}
                  onEdit={onEdit}
                  onDelete={onDelete}
                />
              ))}
            </Table.Body>
          </Table>
        </WrapBlock>
      </WrapModalContent>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  products: state.dishSearch.products,
});

const mapDispatchToProps = (dispatch) => ({
  getProducts: (name) => dispatch(getProducts(name)),
  setProducts: (products) => dispatch(setProducts(products)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductsListModal);

const WrapModalContent = styled.div`
  display: flex;
  flex-direction: column;
`;

const WrapBlock = styled.div`
  margin-top: 5px;
  margin-bottom: 5px;
  width: 100%;
`;



// WEBPACK FOOTER //
// ./src/Components/Dishes/Popups/Dish/Products/ProductsListModal.jsx